export default __webpack_public_path__ + "static/media/GrifitoL-Bold.497b6744.woff2";